export const siteSettings = {
  name: "Prime Finance Markets",
  link: "https://primemarkets.live",
  email: "support@primemarkets.live",
  appLink: "https://app.primemarkets.live",
};
